import { createContext, Dispatch, SetStateAction } from 'react';

export interface CurrentPageContext {
  pageTitle: string;
  setPageTitle: Dispatch<SetStateAction<string>>;
  leftContent: React.ReactNode;
  setLeftContent: Dispatch<SetStateAction<React.ReactNode>>;
  rightContent: React.ReactNode;
  setRightContent: Dispatch<SetStateAction<React.ReactNode>>;
  safeAreaTopColor: string | null;
  setSafeAreaTopColor: Dispatch<SetStateAction<string | null>>;
  isSafeAreaTopFullBleed: boolean;
  setIsSafeAreaTopFullBleed: Dispatch<SetStateAction<boolean>>;
}

export const currentPageContext = createContext<CurrentPageContext>({
  pageTitle: '',
  setPageTitle: () => {},
  leftContent: null,
  setLeftContent: () => {},
  rightContent: null,
  setRightContent: () => {},
  safeAreaTopColor: null,
  setSafeAreaTopColor: () => {},
  isSafeAreaTopFullBleed: false,
  setIsSafeAreaTopFullBleed: () => {},
});
